export const RenameExistingFileModal: string = 'RenameExistingFileModal';
